// extracted by mini-css-extract-plugin
export var configurationSection = "_tg-0";